'use client';

import { useEffect } from 'react';
import { obfuscateLinks } from '@headless-workspace/config';
import {
    AsyncData,
    DynamicHrefValue,
    DynamicIconValue,
    DynamicLabelValue,
    DynamicTagValue,
    ResultEmpty,
    ResultSuccess,
} from '@headless-workspace/core-domain';
import { useUserSession } from '../../../../src';
import { CommonDI, UserSessionRepositoryType } from '../../../DI';
import { findSpecificityRule } from './findSpecificityRule';

export const useFindSpecificityRule = <
    T extends DynamicLabelValue | DynamicIconValue | DynamicHrefValue | DynamicTagValue,
>(
    specificityRules: T[],
): AsyncData<T> => {
    const userSession = useUserSession(CommonDI.get(UserSessionRepositoryType));
    const sessionInitialized =
        !userSession.isLoading && userSession.result.type === 'success' && userSession.result.data.sessionInit;

    useEffect(() => {
        if (typeof document !== 'undefined' && sessionInitialized) {
            obfuscateLinks();
        }
    }, [sessionInitialized]);

    if (sessionInitialized) {
        const userInfo = userSession.result.data.data?.userInfo;
        const specificRule = findSpecificityRule(specificityRules, userInfo);
        if (specificRule) {
            return { isLoading: false, result: ResultSuccess(specificRule) };
        }
        return {
            isLoading: false,
            result: ResultEmpty(),
        };
    }

    return { isLoading: true, result: ResultEmpty() };
};
